export const translations = {
  nl: {
    title: 'Mascotte Survey',
    welcome:
      '👋 Welkom en bedankt dat je meedoet! Deze korte en interactieve enquête bestaat uit 12 vragen. Bij elke vraag zie je 5 mascottes. Sleep ze in de volgorde die voor jou het meest logisch voelt — van 1 (meest passend) tot 5 (minst passend). Niet te lang over nadenken: vertrouw op je eerste indruk!',
    captchaPrompt: 'Verifieer dat je een mens bent',
    privacyTitle: 'Privacy Verklaring',
    privacyIntro:
      'Door deel te nemen aan deze enquête ga je akkoord met het volgende:',
    privacyPoints: [
      'We verzamelen je antwoorden op de enquêtevragen',
      'We slaan basis demografische gegevens op (leeftijd, geslacht, opleiding)',
      'We gebruiken een browser fingerprint om dubbele inzendingen te voorkomen',
      'Je gegevens worden anoniem verwerkt en alleen voor onderzoeksdoeleinden gebruikt',
      'Je kunt maar één keer deelnemen aan deze enquête'
    ],
    privacyConsent:
      'Ik ga akkoord met het verzamelen en verwerken van mijn gegevens zoals hierboven beschreven',
    startButton: 'Start',
    dragInstructions:
      'Sleep om te rangschikken: 1 = meest passend, 5 = minst passend',
    backButton: 'Terug',
    nextButton: 'Volgende',
    backgroundQuestions: 'Achtergrondvragen',
    finalQuestions: 'Nog een paar vragen 🙂',
    age: 'Leeftijd',
    gender: 'Geslacht',
    genderOptions: {
      placeholder: 'Geslacht',
      male: 'Man',
      female: 'Vrouw',
      other: 'Anders'
    },
    education: 'Hoogst behaalde Opleiding',
    educationOptions: {
      placeholder: 'Hoogst behaalde Opleiding',
      primary: 'Basisonderwijs',
      vmbo: 'VMBO/MBO',
      havo: 'HAVO',
      vwo: 'VWO',
      hbo: 'HBO',
      uni: 'WO'
    },
    submitButton: 'Versturen',
    alreadySubmitted: 'Je hebt deze enquête al ingevuld.',
    noMultiple:
      'Het is niet mogelijk om de enquête meerdere keren in te vullen.',
    thanks: 'Bedankt voor je deelname! 🎉',
    redirecting: 'Je wordt doorverwezen naar notso.ai in {seconds} seconden...',
    rankingsIncomplete:
      'Zorg ervoor dat alle mascottes zijn gerangschikt voordat je de enquête verstuurt.',
    submissionError:
      'Er is een fout opgetreden bij het versturen van de gegevens. Probeer het opnieuw.',
    prizeTitle: '🎁 Win een gratis mascotte!',
    prizeDescription:
      'Deel je idee voor een coole mascotte en maak kans op een gratis exemplaar! Laat hieronder je gegevens achter.',
    prizeName: 'Je naam',
    prizeEmail: 'Je email',
    prizeIdea: 'Jouw mascotte idee',
    prizeNamePlaceholder: 'Vul je naam in',
    prizeEmailPlaceholder: 'Vul je email in',
    prizeIdeaPlaceholder: 'Beschrijf je idee voor een coole mascotte...',
    questions: {
      sales_type:
        'Je wint een make-over. Welke digitale assistent mag jouw stylist zijn?',
      friend_type: 'Welke AI-buddy zou jij kiezen als digitale vriend(in)?',
      coach_type:
        'Met welke virtuele coach wil jij samen zweten in de sportschool?',
      support_type:
        'Je pakketje is zoek. Wie wil jij in de klantenservice-chat?',
      mental_type:
        'Tijdens een ademhalingsoefening verschijnt een AI-figuur op je scherm. Wie kies je?',
      hr_type:
        'Het is je eerste werkdag. Wie wil jij als digitale buddy om je wegwijs te maken?',
      sales_style:
        'Je zoekt sneakers in een app. Welke visuele gids zie jij het liefst?',
      friend_style:
        'Je krijgt elke dag een appje van een digitale vriend(in). Welke maakt je blij?',
      coach_style: 'Welke AI-coach motiveert jou het meest in je sport-app?',
      support_style:
        'Je loopt vast in een webshop. Wie wil jij als digitale helper?',
      mental_style:
        'Tijdens meditatie verschijnt een figuur op je scherm. Naar wie kijk je graag?',
      hr_style:
        'Je start een onboarding-app. Welke digitale assistent zie jij het liefst?'
    }
  },
  en: {
    title: 'Mascot Survey',
    welcome:
      "👋 Welcome and thank you for participating! This short interactive survey consists of 12 questions. For each question, you'll see 5 mascots. Drag them in the order that feels most logical to you — from 1 (most suitable) to 5 (least suitable). Don't think too long: trust your first impression!",
    captchaPrompt: "Please verify that you're human",
    privacyTitle: 'Privacy Statement',
    privacyIntro:
      'By participating in this survey, you agree to the following:',
    privacyPoints: [
      'We collect your answers to the survey questions',
      'We store basic demographic data (age, gender, education)',
      'We use a browser fingerprint to prevent multiple submissions',
      'Your data is processed anonymously and used for research purposes only',
      'You can only participate in this survey once'
    ],
    privacyConsent:
      'I agree to the collection and processing of my data as described above',
    startButton: 'Start',
    dragInstructions: 'Drag to rank: 1 = best, 5 = least suitable',
    backButton: 'Back',
    nextButton: 'Next',
    backgroundQuestions: 'Background Questions',
    finalQuestions: 'A few final questions 🙂',
    age: 'Age',
    gender: 'Gender',
    genderOptions: {
      placeholder: 'Gender',
      male: 'Male',
      female: 'Female',
      other: 'Other'
    },
    education: 'Highest Education',
    educationOptions: {
      placeholder: 'Highest Education',
      primary: 'Primary School',
      vmbo: 'Secondary Vocational',
      havo: 'Higher Secondary',
      vwo: 'Pre-University',
      hbo: 'University of Applied Sciences',
      uni: 'University'
    },
    submitButton: 'Submit',
    alreadySubmitted: 'You have already completed this survey.',
    noMultiple: 'It is not possible to complete the survey multiple times.',
    thanks: 'Thank you for participating! 🎉',
    redirecting: 'Redirecting you to notso.ai in {seconds} seconds...',
    rankingsIncomplete: 'Please rank all mascots before submitting the survey.',
    submissionError: 'An error occurred while submitting. Please try again.',
    prizeTitle: '🎁 Win a free mascot!',
    prizeDescription:
      'Share your idea for a cool mascot and win a free copy! Leave your details below.',
    prizeName: 'Your name',
    prizeEmail: 'Your email',
    prizeIdea: 'Your mascot idea',
    prizeNamePlaceholder: 'Enter your name',
    prizeEmailPlaceholder: 'Enter your email',
    prizeIdeaPlaceholder: 'Describe your idea for a cool mascot...',
    questions: {
      sales_type:
        "You've won a makeover. Which digital assistant would you pick as your stylist?",
      friend_type: 'Which AI buddy would you choose as your digital friend?',
      coach_type: 'Which virtual coach would you train with at the gym?',
      support_type:
        'Your package is missing. Who do you want in the support chat?',
      mental_type:
        'During a breathing exercise, one AI figure appears. Who do you prefer?',
      hr_type:
        "It's your first day at work. Who do you want as your digital buddy?",
      sales_style:
        "You're browsing sneakers. Which visual guide would you like to see?",
      friend_style:
        'You get a daily message from a digital friend. Which one makes you smile?',
      coach_style: 'Which AI coach would push you the most in a fitness app?',
      support_style:
        "You're stuck in a webshop. Who do you want as your digital helper?",
      mental_style:
        'During meditation, one figure appears on screen. Who feels most calming?',
      hr_style:
        'You open an onboarding app. Which digital assistant would you choose?'
    }
  }
}
